<template>
<div>
  <!--  <fullscreen v-model="fullscreen">-->
  <!--    &lt;!&ndash;    <button class="form-control btn btn-outline-filter" @click="toggle"> toggle fullscreen</button>&ndash;&gt;-->
  <ve-table
      :max-height="400"
      :fixed-header="true"
      :expand-option="expandOption"
      row-key-field-name="rowKey"
      :virtual-scroll-option="virtualScrollOption"
      :columns="getColumns"
      :sort-option="sortOption"
      :scroll-width="'100vw'"
      :cellSelectionOption="cellSelectionOption"
      :border-y="true"
      :row-style-option="rowStyleOption"
      :table-data="getDownTimesSorted"/>

  <!--  </fullscreen>-->
</div>

</template>

<script>
import timeCalc from "@/mixins/timeCalc";
import {dataTables} from '@/mixins/dataTables';
import downTimesOee from '@/mixins/oeeAnalytics/downTimes'
import {mapGetters} from "vuex";
//      https://github.com/Happy-Coding-Clans/vue-easytable

import VueFullscreen from 'vue-fullscreen'
import Vue from 'vue'
import {sortChange} from "@/mixins/vueEasyTable/sortChange";

Vue.use(VueFullscreen)
export default {
  name: "DownTimeTable",
  mixins: [timeCalc, dataTables, downTimesOee,  sortChange,
],
  props: ['downTimes'],
  data() {
    return {
      fullscreen: false,
      virtualScrollOption: {
        enable: true,
      },
      rowStyleOption: {
        stripe: true,
        clickHighlight: true,
        hoverHighlight: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      expandOption: {
        trigger: "row",
        expandable: ({row, column, rowIndex}) => {
          return !this.fullscreen
          // if (row["comment"].length > 0) {
          //   return true;
          // }
          // return false
        },
        render: ({row, column, rowIndex}, h) => {

          return (
              <table class="table">
                <tr>
                  <th>Start</th>
                  <th>End</th>
                  <th>Comment</th>
                  <th>Declared by</th>
                  <th>Bekijk</th>
                </tr>
                <tr>
                  <td>{row.start.parsedValue} </td>
                  <td> {row.end.parsedValue}</td>
                  <td>{row.comment.parsedValue}</td>
                  <td>{row.declaredBy}</td>
                  <td><a href={row.dtLink} target="_blank"><i class="far fa-eye"></i></a></td>
                </tr>
              </table>

          )
              ;
        },
      },
      rendered: false,
      customFilters: []
    }
  },
  computed: {
    ...mapGetters('company', ['getProductNumberKey']),
    getDownTimesSorted() {
      return _.orderBy(this.getDownTimes, this.getSortKeys, this.getSortOrder)
    },
    getDownTimes() {
      return _.map(this.downTimes, (dt, idx) => {
        return {
          rowKey: dt.id + idx,
          dtLink: `/downtimes/${dt.id}`,
          product: dt.productNumber,
          start: {
            sortValue: Date.parse(dt.downTimeStart),
            parsedValue: this.parseDate(dt.downTimeStart)
          },
          end: {
            sortValue: Date.parse(dt.downTimeEnded),
            parsedValue: this.parseDate(dt.downTimeEnded)
          },
          duration:
              {
                sortValue: dt.duration,
                parsedValue: this.formattedColonTime(dt.duration),
              },
          average: {
            sortValue: dt.averageDownTimeForReason,
            parsedValue: this.formattedColonTime(dt.averageDownTimeForReason),
          },
          reason: this.joinReasonsToString(dt.reason),
          comment: {
            sortValue: dt.comment && dt.comment.length ? 1 : 0,
            parsedValue: dt.comment
          },
          declaredBy: dt.declaredDownTimeBy,
          options: ''
        }
      })
    },
    getFullScreenColumns() {
      return [
        {
          field: "",
          key: "1a",
          type: "expand",
          title: "",
          width: '20',
          align: "left",
          fixed: 'left',
        },
        {
          field: "product",
          key: "1a1",
          title: "Product",
          width: '175px',
          align: "left",
          fixed: 'left',
        },
        {
          field: "start.sortValue", width: '10%', key: "c1", title: "start", align: "left", sortBy: "asc",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                row.start.parsedValue
            );
          }
        },
        {
          field: "end.sortValue", width: '10%', key: "c1", title: "end", align: "left", sortBy: "asc",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                row.end.parsedValue
            );
          }
        },
        {
          field: "duration.sortValue", width: '7%', key: "c1", title: "Duration", align: "left", sortBy: "asc",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                row.duration.parsedValue
            );
          }
        },
        {
          field: "average.sortValue", width: '7%', key: "c2", title: "Average", align: "left", sortBy: "asc",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                row.average.parsedValue
            );
          }
        },
        {field: "reason", width: "45%", key: "d", title: "Reason", align: "left"},
        {field: "comment", width: "50%", key: "e", title: "Comment", align: "left"},
        {field: "declaredBy", width: "6%", key: "f", title: "Declared by", align: "left"},
        {field: "options", key: "g", title: "Options", align: "left"},
      ]

    },
    getColumns() {
      if (this.fullscreen) {
        return this.getFullScreenColumns
      }
      return [
        {
          field: "",
          key: "1",
          type: "expand",
          title: "",
          width: "2%",
          align: "left",
          fixed: 'left',
        },
        {
          field: "product",
          key: "2",
          title: "Product",
          width: "6%",
          align: "left",
          fixed: 'left',
        },
        //  {
        //   field: "start", width: "11%", key: "b", title: "Start", align: "left", sortBy: "asc",
        //   renderBodyCell: ({row, column, rowIndex}, h) => {
        //     return (
        //         row.start.parsedValue
        //     );
        //   },
        // },
        // {field: "end", width: "11%", key: "c", title: "End", align: "left"},
        {
          field: "duration.sortValue", width: "6%", key: "c1", title: "Duration", align: "left", sortBy: "desc",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                row.duration.parsedValue
            );
          }
        },
        {
          field: "average.sortValue", width: "6%", key: "c2", title: "Average", align: "left", sortBy: "",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                row.average.parsedValue
            );
          }
        },
        {field: "reason", width: "40%", key: "d", title: "Reason", align: "left"},
        {
          field: "comment.sortValue", width: "40%", key: "e", title: "Comment", align: "left", sortBy: "",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (
                row.comment.parsedValue
            );
          }
        },
        // {field: "declaredBy", key: "f", title: "Declared by", align: "left"},

      ]

    },
  },
  methods: {
    toggle() {
      this.fullscreen = !this.fullscreen
    },
    toggleApi() {
      this.$fullscreen.toggle()
    },
    parseDate(date) {
      return moment(date).format('DD/MM/YY HH:mm')
    },
  },
  created() {

  }
}
</script>

<style scoped>


</style>

<style>

/*div#downtimes-dt-analytics_wrapper div.dataTables_filter label {*/
/*  display: block;*/
/*  width: 100% !important;*/

/*}*/

/*div#downtimes-dt-analytics_wrapper div.dataTables_filter input {*/
/*  width: 100% !important;*/
/*  margin: 0;*/
/* }*/

</style>
